
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground } from 'docz'
import './grid'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "grid"
    }}>{`Grid`}</h1>
    <hr />
    <h2 {...{
      "id": "grid-1"
    }}>{`Grid`}</h2>
    <h3 {...{
      "id": "screen-sizes-below-800px"
    }}>{`Screen sizes below 800px`}</h3>
    <Playground __position={1} __code={'<code>\n  --ds-grid-gap: 0.75rem; /* 12px */\n  <br />\n  --ds-grid-gutter: 1.5rem; /* 24px */\n  <br />\n</code>'} __scope={{
      props: this ? this.props : props,
      Playground
    }} mdxType="Playground">
  <code>
  --ds-grid-gap: 0.75rem; /* 12px */<br />
  --ds-grid-gutter: 1.5rem; /* 24px */<br />
  </code>
    </Playground>
    <h3 {...{
      "id": "screen-sizes-above-800px"
    }}>{`Screen sizes above 800px`}</h3>
    <Playground __position={2} __code={'<code>\n  --ds-grid-gap: 0.75rem; /* 16px */\n  <br />\n  --ds-grid-gutter: 1.5rem; /* 32px */\n  <br />\n</code>'} __scope={{
      props: this ? this.props : props,
      Playground
    }} mdxType="Playground">
  <code>
  --ds-grid-gap: 0.75rem; /* 16px */<br />
  --ds-grid-gutter: 1.5rem; /* 32px */<br />
  </code>
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;